import { Module } from 'vuex'
import { getters } from './getters'

export const module: Module<any, any> = {
  namespaced: true,
  getters,
}
